import LoginPage from 'components/LoginPage';
import i18n, { changeLanguage } from 'i18n';
import { AuthenticateData } from 'modules/authenticate/interfaces';
import React, { useCallback } from 'react';
import { connect } from 'react-redux';
import { history } from 'store';
import { ethicsLink, privacyLink, superUser } from 'utils/helpers';
import useWindowDimensions from 'hooks/useWindowWidth';
import UserLoginForm from './components/UserLoginForm';

interface OwnProps {
  data: AuthenticateData;
}

const UserLogin: React.FC<OwnProps> = ({ data }) => {
  const { width } = useWindowDimensions();

  const redirectToPage = useCallback(() => {
    let urlToRedirect = '/all-environments';

    if (!superUser(data?.role)) {
      urlToRedirect = data?.permissions?.list_environment
        ? '/environments'
        : '/clients';
    }
    history.push(urlToRedirect);
  }, [data]);

  React.useEffect(() => {
    if (data?.token && !data?.mfa?.required) {
      redirectToPage();
    }
  }, [data, redirectToPage]);

  React.useEffect(() => {
    if (
      !sessionStorage.getItem('language') ||
      !localStorage.getItem('language')
    ) {
      const lang = ['en-US', 'pt-BR', 'es-ES'].includes(navigator.language);
      if (navigator.language === 'es') {
        changeLanguage('es-ES');
      } else {
        changeLanguage(lang ? navigator.language : 'en-US');
      }
    }
  }, []);

  const image =
    width < 960
      ? '/images/login/mobileImage.png'
      : '/images/login/login1WithLogo.png';

  return (
    <LoginPage
      logoHeaderUrl="/images/AutoSkyLogoColorido.svg"
      backgroundImageUrl={image}
      links={[
        {
          name: i18n.t('PRIVACY_POLICY_KEY'),
          url: privacyLink[i18n.language],
        },
        {
          name: i18n.t('CODE_OF_ETHICS_KEY'),
          url: ethicsLink[i18n.language],
        },
      ]}
    >
      <UserLoginForm language={i18n.language} />
    </LoginPage>
  );
};

const mapStateToProps = ({ authenticate }) => ({
  data: authenticate.data,
});

export default connect(mapStateToProps)(UserLogin);
